import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

/**
 * Thin wrapper over `useMutation` that pre-fills `TError = AxiosError`.
 *
 * Backed by the single `apiClient` axios instance in `@/services/api/client.ts` —
 * every request and therefore every error flows through it. Wire-level error
 * is always `AxiosError`; payload shape (`error.response.data`) stays loose
 * because backend error bodies vary across endpoints.
 *
 * When a specific mutation needs a typed error body, override per call:
 *   useMutation<TData, AxiosError<MyShape>, TVars>({ ... })
 */
export const useApiMutation = <TData, TVars>(
  options: UseMutationOptions<TData, AxiosError, TVars>,
) => useMutation<TData, AxiosError, TVars>(options);
